export const FLUX_LORA_GENERATION_COST = 0.035;